import { StyledLoader } from './style';

export const LoaderSmallCentralized:React.FC = () => <StyledLoader />;
